/* eslint-disable */

if (window.location.host.match('yandex')) {
    const path = window.location.pathname.replace('index.html', '');
    __webpack_public_path__ = window.location.origin + path;
    console.log('LP', __webpack_public_path__);
}
